import { Typography } from '@mui/material';
import React, { type ReactNode } from 'react';
import I18n from '../../../i18n/I18n';

export type PanelNoAccessProps = {
    hint?: ReactNode;
};

export function PanelNoAccess({ hint }: PanelNoAccessProps) {
    return (
        <div role="status" aria-live="polite">
            <Typography component="h2" variant="h6">
                <I18n token="common.content.access.permission.denied.title" />
            </Typography>
            <Typography>
                <I18n token="common.content.access.permission.denied.message" />
            </Typography>
            {hint}
        </div>
    );
}
